import { render, staticRenderFns } from "./StaticView.vue?vue&type=template&id=f11a6780"
import script from "./StaticView.vue?vue&type=script&lang=js"
export * from "./StaticView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports